export default "__VITE_ASSET__39be85d1__"